import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SIDENAV_KEYS, DIALOG_KEYS } from '../../utils/translation-constants'
import NumberFormat from 'react-number-format'
export default function ServiceRequestCard({ icon, title, time, transaction }) {
  const [expanded, setExpanded] = useState(false)
  const { t } = useTranslation()
  return (
    <div>
      <div className='py-4 d-flex align-items-center ro' onClick={() => setExpanded(!expanded)}>
        <div className='d-flex justify-content-start align-items-center ro' style={{ flex: 0.5 }}>
          <div style={{ width: 38, height: 38 }}>{icon()}</div>
        </div>
        <div className='d-flex flex-column ml-3' style={{ flex: 5 }}>
          <h5 className='mb-1 font-weight-500'>{title}</h5>
          <h6 className='mb-0 small text-gray'>{time}</h6>
        </div>
        {/* <div className='d-flex flex-column align-items-end' style={{ flex: 1.5 }}>
          <h5
            className='mb-1 font-weight-500'>
            {amount}
          </h5>
        </div> */}
      </div>
      {expanded ? (
        <div>
          <div className='row mt-1 d-flex justify-content-around'>
            <div className='my-3 d-flex col-6 justify-content-between align-items-center ro'>
              <h6 className='ml-1 text-gray col-6'>
                {t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.SERVICEREQREFNO)}
              </h6>
              <h6 className='col-6'>{transaction.serviceReqRef}</h6>
            </div>
            <div className='my-3 d-flex col-6 justify-content-between align-items-center ro'>
              <h6 className='ml-1 text-gray col-6'>
                {t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.REFERENCENO)}
              </h6>
              <h6 className='col-6'>{transaction.referenceNo}</h6>
            </div>
          </div>
          <div className='row mt-1 d-flex justify-content-around'>
            <div className='my-3 d-flex col-6 justify-content-between align-items-center ro'>
              <h6 className='ml-1 text-gray col-6'>
                {t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.CUSTOMERNAME)}
              </h6>
              <h6 className='col-6'>{transaction.customerName}</h6>
            </div>
            <div className='my-3 d-flex col-6 justify-content-between align-items-center ro'>
              <h6 className='ml-1 text-gray col-6'>
                {t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.EMAILID)}
              </h6>
              <h6 className='col-6'>{transaction.emailId}</h6>
            </div>
          </div>
          <div className='row mt-1 d-flex justify-content-around'>
            <div className='my-3 d-flex col-6 justify-content-between align-items-center ro'>
              <h6 className='ml-1 text-gray col-6'>
                {t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.ACCOUNTNO)}
              </h6>
              <h6 className='col-6'>{transaction.accountNo}</h6>
            </div>
            <div className='my-3 d-flex col-6 justify-content-between align-items-center ro'>
              <h6 className='ml-1 text-gray col-6'>
                {t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.status)}
              </h6>
              <h6 className='col-6'>{transaction.status}</h6>
            </div>
          </div>
          <div className='row mt-1 d-flex justify-content-around'>
            <div className='my-3 d-flex col-6 justify-content-between align-items-center ro'>
              <h6 className='ml-1 text-gray col-6'>
                {t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.REMARKS)}
              </h6>
              <h6 className='col-6'>{transaction.remarks}</h6>
            </div>
            <div className='my-3 d-flex col-6 justify-content-between align-items-center ro'>
              <h6 className='ml-1 text-gray col-6'>
                {t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.SUGGESTION)}
              </h6>
              <h6 className='col-6'>{transaction.suggestion}</h6>
            </div>
          </div>

          <div className='row mt-1 d-flex justify-content-around'>
            <div className='my-3 d-flex col-6 justify-content-between align-items-center ro'>
              <h6 className='ml-1 text-gray col-6'>
                {t(SIDENAV_KEYS.SERVICEREQUEST_VIEW_KEYS.AMOUNT)}
              </h6>
              <h6 className='col-6'>
                <NumberFormat
                  value={transaction.amount}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={''}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  allowEmptyFormatting
                />
              </h6>
            </div>
            <div className='my-3 d-flex col-6 justify-content-between align-items-center ro'></div>
          </div>
        </div>
      ) : null}
    </div>
  )
}
